import * as Yup from "yup";
import { EmployeeAdvanceValueType } from "features/EmployeeAdvances/constants/employee-advance.constants";

const schema = Yup.object({
  employeeId: Yup.number().required("The employee field is required"),

  valueType: Yup.mixed<EmployeeAdvanceValueType>()
    .oneOf(Object.values(EmployeeAdvanceValueType))
    .required("Value type is required"),

  /** Rupee amount when FIXED; percentage when PERCENTAGE. */
  value: Yup.number()
    .typeError("Enter a valid number")
    .when("valueType", {
      is: EmployeeAdvanceValueType.FIXED,
      then: (s) =>
        s
          .positive("Amount must be greater than zero")
          .required("Amount is required"),
      otherwise: (s) =>
        s
          .positive("Percentage must be greater than zero")
          .max(100, "Percentage cannot exceed 100")
          .required("Percentage is required"),
    }),

  remarks: Yup.string().nullable(),
  purpose: Yup.string().nullable(),
  isEdit: Yup.boolean(),
  markAsPaid: Yup.boolean(),
  /** Required on create when markAsPaid is true (or omitted); not applicable on edit. */
  modeOfPaymentId: Yup.number()
    .nullable()
    .test(
      "required-when-marking-paid",
      "Mode of payment is required",
      function (val) {
        const { isEdit, markAsPaid } = this.parent;
        if (isEdit || markAsPaid === false) return true;
        return val != null;
      },
    ),
  paymentDate: Yup.string().nullable(),
  referenceNumber: Yup.string().nullable(),
});

export default schema;
